/**
 * Extension → default app, exactly like the real thing. `openFile()` consults
 * this table; adding a new file type is a one-line change here plus an app.
 */
export interface Association {
  /** App id to launch. `'*'` means "read it from the file's own data". */
  appId: string;
  icon: string;
  /** How the file's path is passed to the app. */
  argKey?: string;
  /** Shown in Explorer's Type column. */
  typeName: string;
}

export const fileAssociations: Record<string, Association> = {
  '.txt': { appId: 'notepad', icon: '/assets/icons/txt.svg', argKey: 'file', typeName: 'Text Document' },
  '.md': { appId: 'notepad', icon: '/assets/icons/txt.svg', argKey: 'file', typeName: 'Text Document' },
  '.log': { appId: 'notepad', icon: '/assets/icons/txt.svg', argKey: 'file', typeName: 'Text Document' },
  '.ini': { appId: 'notepad', icon: '/assets/icons/txt.svg', argKey: 'file', typeName: 'Configuration Settings' },
  '.url': { appId: 'ie', icon: '/assets/icons/url.svg', typeName: 'Internet Shortcut' },
  '.lnk': { appId: '*', icon: '/assets/icons/lnk.svg', typeName: 'Shortcut' },
  // Paint is the picture viewer here, as it was on a fresh XP install before
  // anyone got round to installing something better.
  '.bmp': { appId: 'paint', icon: '/assets/icons/image.svg', argKey: 'file', typeName: 'Bitmap Image' },
  '.png': { appId: 'paint', icon: '/assets/icons/image.svg', argKey: 'file', typeName: 'PNG Image' },
  '.jpg': { appId: 'paint', icon: '/assets/icons/image.svg', argKey: 'file', typeName: 'JPEG Image' },
  '.gif': { appId: 'paint', icon: '/assets/icons/image.svg', argKey: 'file', typeName: 'GIF Image' },
  // Media Player owned `.mp3` on a fresh XP, and kept it until Winamp asked.
  // The file's own data names which track it holds, so no `argKey`: what gets
  // passed is a track, not a path.
  '.mp3': { appId: 'mediaplayer', icon: '/assets/icons/media.svg', typeName: 'MP3 Format Sound' },
  // Winamp took `.m3u` off Windows the moment you installed it, and kept it.
  '.m3u': { appId: 'winamp', icon: '/assets/icons/playlist.svg', typeName: 'Winamp Media File' },
};

export function associationFor(ext: string): Association | undefined {
  return fileAssociations[ext.toLowerCase()];
}
